export const gongcai = {
    "id": 2206,
    "name": "供应商",
    "component": "Layout",
    "path": "",
    "icon": "",
    "layout": "1",
    "router_name": "weishopapplication",
    "vue_name": "",
    "app_level": 1,
    "plugin": {
        "id": 84,
        "title": "供应商",
        "description": "通过系统化管理外部合作伙伴，旨在优化成本、保障供应稳定、提升协同效率，最终增强企业供应链的竞争力和韧性",
        "image": "746842",
        "cat_id": 4,
        "price": "158.00",
        "billing_type": 1,
        "store_show_status": 0,
        "plugin_key": "weishop_supplier",
        "billing_type_text": "付费",
        "image_url": "https://qiniuyun.mocols.com/upload/images/20260608/202606081131562810.png",
        "cat": {
            "id": 4,
            "title": "线下零售"
        },
        "access": {
            "billing_type": 1,
            "billing_type_text": "付费",
            "price": "158.00",
            "is_free": false,
            "is_opened": true,
            "can_use": true,
            "buy_status": "opened",
            "license_type": 10,
            "license_type_text": "永久开通",
            "valid_until": "",
            "is_trial": false,
            "is_expired": false
        },
        "plugin_access": {
            "billing_type": 1,
            "billing_type_text": "付费",
            "price": "158.00",
            "is_free": false,
            "is_opened": true,
            "can_use": true,
            "buy_status": "opened",
            "license_type": 10,
            "license_type_text": "永久开通",
            "valid_until": "",
            "is_trial": false,
            "is_expired": false
        }
    },
    "is_plugin": 0,
    "_child": [
        {
            "id": 2208,
            "name": "商家管理",
            "component": "Layout",
            "path": "",
            "icon": "https://mp.mocols.com/storage/upload/file/20251222/20251222184556334.svg",
            "layout": "1",
            "router_name": "weishopapplication",
            "vue_name": "",
            "app_level": 0,
            "plugin": {
                "id": 84,
                "title": "供应商",
                "description": "通过系统化管理外部合作伙伴，旨在优化成本、保障供应稳定、提升协同效率，最终增强企业供应链的竞争力和韧性",
                "image": "746842",
                "cat_id": 4,
                "price": "158.00",
                "billing_type": 1,
                "store_show_status": 0,
                "plugin_key": "weishop_supplier",
                "billing_type_text": "付费",
                "image_url": "https://qiniuyun.mocols.com/upload/images/20260608/202606081131562810.png",
                "cat": {
                    "id": 4,
                    "title": "线下零售"
                },
                "access": {
                    "billing_type": 1,
                    "billing_type_text": "付费",
                    "price": "158.00",
                    "is_free": false,
                    "is_opened": true,
                    "can_use": true,
                    "buy_status": "opened",
                    "license_type": 10,
                    "license_type_text": "永久开通",
                    "valid_until": "",
                    "is_trial": false,
                    "is_expired": false
                },
                "plugin_access": {
                    "billing_type": 1,
                    "billing_type_text": "付费",
                    "price": "158.00",
                    "is_free": false,
                    "is_opened": true,
                    "can_use": true,
                    "buy_status": "opened",
                    "license_type": 10,
                    "license_type_text": "永久开通",
                    "valid_until": "",
                    "is_trial": false,
                    "is_expired": false
                }
            },
            "is_plugin": 0,
            "_child": [
                {
                    "id": 2212,
                    "name": "商家列表",
                    "component": "apps/weishop/shop/application/supplier/user.vue",
                    "path": "/weishop/shop/application/supplier/user",
                    "icon": "",
                    "layout": "1",
                    "router_name": "weishopapplication",
                    "vue_name": "",
                    "app_level": 0,
                    "plugin": {
                        "id": 84,
                        "title": "供应商",
                        "description": "通过系统化管理外部合作伙伴，旨在优化成本、保障供应稳定、提升协同效率，最终增强企业供应链的竞争力和韧性",
                        "image": "746842",
                        "cat_id": 4,
                        "price": "158.00",
                        "billing_type": 1,
                        "store_show_status": 0,
                        "plugin_key": "weishop_supplier",
                        "billing_type_text": "付费",
                        "image_url": "https://qiniuyun.mocols.com/upload/images/20260608/202606081131562810.png",
                        "cat": {
                            "id": 4,
                            "title": "线下零售"
                        },
                        "access": {
                            "billing_type": 1,
                            "billing_type_text": "付费",
                            "price": "158.00",
                            "is_free": false,
                            "is_opened": true,
                            "can_use": true,
                            "buy_status": "opened",
                            "license_type": 10,
                            "license_type_text": "永久开通",
                            "valid_until": "",
                            "is_trial": false,
                            "is_expired": false
                        },
                        "plugin_access": {
                            "billing_type": 1,
                            "billing_type_text": "付费",
                            "price": "158.00",
                            "is_free": false,
                            "is_opened": true,
                            "can_use": true,
                            "buy_status": "opened",
                            "license_type": 10,
                            "license_type_text": "永久开通",
                            "valid_until": "",
                            "is_trial": false,
                            "is_expired": false
                        }
                    },
                    "is_plugin": 0,
                    "_child": []
                },
                {
                    "id": 2213,
                    "name": "分组管理",
                    "component": "apps/weishop/shop/application/supplier/group.vue",
                    "path": "/weishop/shop/application/supplier/group",
                    "icon": "",
                    "layout": "1",
                    "router_name": "weishopapplication",
                    "vue_name": "",
                    "app_level": 0,
                    "plugin": {
                        "id": 84,
                        "title": "供应商",
                        "description": "通过系统化管理外部合作伙伴，旨在优化成本、保障供应稳定、提升协同效率，最终增强企业供应链的竞争力和韧性",
                        "image": "746842",
                        "cat_id": 4,
                        "price": "158.00",
                        "billing_type": 1,
                        "store_show_status": 0,
                        "plugin_key": "weishop_supplier",
                        "billing_type_text": "付费",
                        "image_url": "https://qiniuyun.mocols.com/upload/images/20260608/202606081131562810.png",
                        "cat": {
                            "id": 4,
                            "title": "线下零售"
                        },
                        "access": {
                            "billing_type": 1,
                            "billing_type_text": "付费",
                            "price": "158.00",
                            "is_free": false,
                            "is_opened": true,
                            "can_use": true,
                            "buy_status": "opened",
                            "license_type": 10,
                            "license_type_text": "永久开通",
                            "valid_until": "",
                            "is_trial": false,
                            "is_expired": false
                        },
                        "plugin_access": {
                            "billing_type": 1,
                            "billing_type_text": "付费",
                            "price": "158.00",
                            "is_free": false,
                            "is_opened": true,
                            "can_use": true,
                            "buy_status": "opened",
                            "license_type": 10,
                            "license_type_text": "永久开通",
                            "valid_until": "",
                            "is_trial": false,
                            "is_expired": false
                        }
                    },
                    "is_plugin": 0,
                    "_child": []
                },
                {
                    "id": 2216,
                    "name": "新增供应商",
                    "component": "apps/weishop/shop/application/supplier/user_add.vue",
                    "path": "/weishop/shop/application/supplier/user_add",
                    "icon": "",
                    "layout": "2",
                    "router_name": "weishopapplication",
                    "vue_name": "",
                    "app_level": 0,
                    "plugin": {
                        "id": 84,
                        "title": "供应商",
                        "description": "通过系统化管理外部合作伙伴，旨在优化成本、保障供应稳定、提升协同效率，最终增强企业供应链的竞争力和韧性",
                        "image": "746842",
                        "cat_id": 4,
                        "price": "158.00",
                        "billing_type": 1,
                        "store_show_status": 0,
                        "plugin_key": "weishop_supplier",
                        "billing_type_text": "付费",
                        "image_url": "https://qiniuyun.mocols.com/upload/images/20260608/202606081131562810.png",
                        "cat": {
                            "id": 4,
                            "title": "线下零售"
                        },
                        "access": {
                            "billing_type": 1,
                            "billing_type_text": "付费",
                            "price": "158.00",
                            "is_free": false,
                            "is_opened": true,
                            "can_use": true,
                            "buy_status": "opened",
                            "license_type": 10,
                            "license_type_text": "永久开通",
                            "valid_until": "",
                            "is_trial": false,
                            "is_expired": false
                        },
                        "plugin_access": {
                            "billing_type": 1,
                            "billing_type_text": "付费",
                            "price": "158.00",
                            "is_free": false,
                            "is_opened": true,
                            "can_use": true,
                            "buy_status": "opened",
                            "license_type": 10,
                            "license_type_text": "永久开通",
                            "valid_until": "",
                            "is_trial": false,
                            "is_expired": false
                        }
                    },
                    "is_plugin": 0,
                    "_child": []
                }
            ]
        },
        {
            "id": 2209,
            "name": "订单管理",
            "component": "Layout",
            "path": "",
            "icon": "https://mp.mocols.com/storage/upload/file/20251219/202512191223175562.svg",
            "layout": "1",
            "router_name": "weishopapplication",
            "vue_name": "",
            "app_level": 0,
            "plugin": {
                "id": 84,
                "title": "供应商",
                "description": "通过系统化管理外部合作伙伴，旨在优化成本、保障供应稳定、提升协同效率，最终增强企业供应链的竞争力和韧性",
                "image": "746842",
                "cat_id": 4,
                "price": "158.00",
                "billing_type": 1,
                "store_show_status": 0,
                "plugin_key": "weishop_supplier",
                "billing_type_text": "付费",
                "image_url": "https://qiniuyun.mocols.com/upload/images/20260608/202606081131562810.png",
                "cat": {
                    "id": 4,
                    "title": "线下零售"
                },
                "access": {
                    "billing_type": 1,
                    "billing_type_text": "付费",
                    "price": "158.00",
                    "is_free": false,
                    "is_opened": true,
                    "can_use": true,
                    "buy_status": "opened",
                    "license_type": 10,
                    "license_type_text": "永久开通",
                    "valid_until": "",
                    "is_trial": false,
                    "is_expired": false
                },
                "plugin_access": {
                    "billing_type": 1,
                    "billing_type_text": "付费",
                    "price": "158.00",
                    "is_free": false,
                    "is_opened": true,
                    "can_use": true,
                    "buy_status": "opened",
                    "license_type": 10,
                    "license_type_text": "永久开通",
                    "valid_until": "",
                    "is_trial": false,
                    "is_expired": false
                }
            },
            "is_plugin": 0,
            "_child": [
                {
                    "id": 2214,
                    "name": "订单管理",
                    "component": "apps/weishop/shop/application/supplier/order.vue",
                    "path": "/weishop/shop/application/supplier/order",
                    "icon": "",
                    "layout": "1",
                    "router_name": "weishopapplication",
                    "vue_name": "",
                    "app_level": 0,
                    "plugin": {
                        "id": 84,
                        "title": "供应商",
                        "description": "通过系统化管理外部合作伙伴，旨在优化成本、保障供应稳定、提升协同效率，最终增强企业供应链的竞争力和韧性",
                        "image": "746842",
                        "cat_id": 4,
                        "price": "158.00",
                        "billing_type": 1,
                        "store_show_status": 0,
                        "plugin_key": "weishop_supplier",
                        "billing_type_text": "付费",
                        "image_url": "https://qiniuyun.mocols.com/upload/images/20260608/202606081131562810.png",
                        "cat": {
                            "id": 4,
                            "title": "线下零售"
                        },
                        "access": {
                            "billing_type": 1,
                            "billing_type_text": "付费",
                            "price": "158.00",
                            "is_free": false,
                            "is_opened": true,
                            "can_use": true,
                            "buy_status": "opened",
                            "license_type": 10,
                            "license_type_text": "永久开通",
                            "valid_until": "",
                            "is_trial": false,
                            "is_expired": false
                        },
                        "plugin_access": {
                            "billing_type": 1,
                            "billing_type_text": "付费",
                            "price": "158.00",
                            "is_free": false,
                            "is_opened": true,
                            "can_use": true,
                            "buy_status": "opened",
                            "license_type": 10,
                            "license_type_text": "永久开通",
                            "valid_until": "",
                            "is_trial": false,
                            "is_expired": false
                        }
                    },
                    "is_plugin": 0,
                    "_child": []
                },
                {
                    "id": 2215,
                    "name": "售后订单",
                    "component": "apps/weishop/shop/application/supplier/sales.vue",
                    "path": "/weishop/shop/application/supplier/sales",
                    "icon": "",
                    "layout": "1",
                    "router_name": "weishopapplication",
                    "vue_name": "",
                    "app_level": 0,
                    "plugin": {
                        "id": 84,
                        "title": "供应商",
                        "description": "通过系统化管理外部合作伙伴，旨在优化成本、保障供应稳定、提升协同效率，最终增强企业供应链的竞争力和韧性",
                        "image": "746842",
                        "cat_id": 4,
                        "price": "158.00",
                        "billing_type": 1,
                        "store_show_status": 0,
                        "plugin_key": "weishop_supplier",
                        "billing_type_text": "付费",
                        "image_url": "https://qiniuyun.mocols.com/upload/images/20260608/202606081131562810.png",
                        "cat": {
                            "id": 4,
                            "title": "线下零售"
                        },
                        "access": {
                            "billing_type": 1,
                            "billing_type_text": "付费",
                            "price": "158.00",
                            "is_free": false,
                            "is_opened": true,
                            "can_use": true,
                            "buy_status": "opened",
                            "license_type": 10,
                            "license_type_text": "永久开通",
                            "valid_until": "",
                            "is_trial": false,
                            "is_expired": false
                        },
                        "plugin_access": {
                            "billing_type": 1,
                            "billing_type_text": "付费",
                            "price": "158.00",
                            "is_free": false,
                            "is_opened": true,
                            "can_use": true,
                            "buy_status": "opened",
                            "license_type": 10,
                            "license_type_text": "永久开通",
                            "valid_until": "",
                            "is_trial": false,
                            "is_expired": false
                        }
                    },
                    "is_plugin": 0,
                    "_child": []
                }
            ]
        },
        {
            "id": 2210,
            "name": "结算管理",
            "component": "apps/weishop/shop/application/supplier/bill.vue",
            "path": "/weishop/shop/application/supplier/bill",
            "icon": "https://mp.mocols.com/storage/upload/file/20251204/202512041651589785.svg",
            "layout": "1",
            "router_name": "weishopapplication",
            "vue_name": "",
            "app_level": 0,
            "plugin": {
                "id": 84,
                "title": "供应商",
                "description": "通过系统化管理外部合作伙伴，旨在优化成本、保障供应稳定、提升协同效率，最终增强企业供应链的竞争力和韧性",
                "image": "746842",
                "cat_id": 4,
                "price": "158.00",
                "billing_type": 1,
                "store_show_status": 0,
                "plugin_key": "weishop_supplier",
                "billing_type_text": "付费",
                "image_url": "https://qiniuyun.mocols.com/upload/images/20260608/202606081131562810.png",
                "cat": {
                    "id": 4,
                    "title": "线下零售"
                },
                "access": {
                    "billing_type": 1,
                    "billing_type_text": "付费",
                    "price": "158.00",
                    "is_free": false,
                    "is_opened": true,
                    "can_use": true,
                    "buy_status": "opened",
                    "license_type": 10,
                    "license_type_text": "永久开通",
                    "valid_until": "",
                    "is_trial": false,
                    "is_expired": false
                },
                "plugin_access": {
                    "billing_type": 1,
                    "billing_type_text": "付费",
                    "price": "158.00",
                    "is_free": false,
                    "is_opened": true,
                    "can_use": true,
                    "buy_status": "opened",
                    "license_type": 10,
                    "license_type_text": "永久开通",
                    "valid_until": "",
                    "is_trial": false,
                    "is_expired": false
                }
            },
            "is_plugin": 0,
            "_child": []
        },
        {
            "id": 2211,
            "name": "基础设置",
            "component": "apps/weishop/shop/application/supplier/set.vue",
            "path": "/weishop/shop/application/supplier/set",
            "icon": "https://mp.mocols.com/storage/upload/file/20251204/202512040909005563.svg",
            "layout": "1",
            "router_name": "weishopapplication",
            "vue_name": "",
            "app_level": 0,
            "plugin": {
                "id": 84,
                "title": "供应商",
                "description": "通过系统化管理外部合作伙伴，旨在优化成本、保障供应稳定、提升协同效率，最终增强企业供应链的竞争力和韧性",
                "image": "746842",
                "cat_id": 4,
                "price": "158.00",
                "billing_type": 1,
                "store_show_status": 0,
                "plugin_key": "weishop_supplier",
                "billing_type_text": "付费",
                "image_url": "https://qiniuyun.mocols.com/upload/images/20260608/202606081131562810.png",
                "cat": {
                    "id": 4,
                    "title": "线下零售"
                },
                "access": {
                    "billing_type": 1,
                    "billing_type_text": "付费",
                    "price": "158.00",
                    "is_free": false,
                    "is_opened": true,
                    "can_use": true,
                    "buy_status": "opened",
                    "license_type": 10,
                    "license_type_text": "永久开通",
                    "valid_until": "",
                    "is_trial": false,
                    "is_expired": false
                },
                "plugin_access": {
                    "billing_type": 1,
                    "billing_type_text": "付费",
                    "price": "158.00",
                    "is_free": false,
                    "is_opened": true,
                    "can_use": true,
                    "buy_status": "opened",
                    "license_type": 10,
                    "license_type_text": "永久开通",
                    "valid_until": "",
                    "is_trial": false,
                    "is_expired": false
                }
            },
            "is_plugin": 0,
            "_child": []
        },
        {
            "id": 2207,
            "name": "数据概况",
            "component": "apps/weishop/shop/application/supplier/overview.vue",
            "path": "/weishop/shop/application/supplier/overview",
            "icon": "https://mp.mocols.com/storage/upload/file/20251212/202512121402529908.svg",
            "layout": "2",
            "router_name": "weishopapplication",
            "vue_name": "",
            "app_level": 0,
            "plugin": {
                "id": 84,
                "title": "供应商",
                "description": "通过系统化管理外部合作伙伴，旨在优化成本、保障供应稳定、提升协同效率，最终增强企业供应链的竞争力和韧性",
                "image": "746842",
                "cat_id": 4,
                "price": "158.00",
                "billing_type": 1,
                "store_show_status": 0,
                "plugin_key": "weishop_supplier",
                "billing_type_text": "付费",
                "image_url": "https://qiniuyun.mocols.com/upload/images/20260608/202606081131562810.png",
                "cat": {
                    "id": 4,
                    "title": "线下零售"
                },
                "access": {
                    "billing_type": 1,
                    "billing_type_text": "付费",
                    "price": "158.00",
                    "is_free": false,
                    "is_opened": true,
                    "can_use": true,
                    "buy_status": "opened",
                    "license_type": 10,
                    "license_type_text": "永久开通",
                    "valid_until": "",
                    "is_trial": false,
                    "is_expired": false
                },
                "plugin_access": {
                    "billing_type": 1,
                    "billing_type_text": "付费",
                    "price": "158.00",
                    "is_free": false,
                    "is_opened": true,
                    "can_use": true,
                    "buy_status": "opened",
                    "license_type": 10,
                    "license_type_text": "永久开通",
                    "valid_until": "",
                    "is_trial": false,
                    "is_expired": false
                }
            },
            "is_plugin": 0,
            "_child": []
        }
    ]
}